/**
 * @generated SignedSource<<759d08eb16ac0501317081dfa5064e8e>>
 * @relayHash 75421fbe12c4e07755e857a39b840d29
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 75421fbe12c4e07755e857a39b840d29

import { ConcreteRequest } from 'relay-runtime';
export type Ch_deleteNeuropsychologicDiagnosticPrescriptionInput = {
  id: string;
};
export type useChDeleteNeuropsychologicDiagnosticPrescriptionMutation$variables = {
  input: Ch_deleteNeuropsychologicDiagnosticPrescriptionInput;
};
export type useChDeleteNeuropsychologicDiagnosticPrescriptionMutation$data = {
  readonly ch_deleteNeuropsychologicDiagnosticPrescription: {
    readonly ch_NeuropsychologicDiagnosticPrescription: {
      readonly id: string;
    } | null;
  };
};
export type useChDeleteNeuropsychologicDiagnosticPrescriptionMutation = {
  response: useChDeleteNeuropsychologicDiagnosticPrescriptionMutation$data;
  variables: useChDeleteNeuropsychologicDiagnosticPrescriptionMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useChDeleteNeuropsychologicDiagnosticPrescriptionMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "Ch_deleteNeuropsychologicDiagnosticPrescriptionPayload",
        "kind": "LinkedField",
        "name": "ch_deleteNeuropsychologicDiagnosticPrescription",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ch_NeuropsychologicDiagnosticPrescription",
            "kind": "LinkedField",
            "name": "ch_NeuropsychologicDiagnosticPrescription",
            "plural": false,
            "selections": [
              (v2/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useChDeleteNeuropsychologicDiagnosticPrescriptionMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "Ch_deleteNeuropsychologicDiagnosticPrescriptionPayload",
        "kind": "LinkedField",
        "name": "ch_deleteNeuropsychologicDiagnosticPrescription",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ch_NeuropsychologicDiagnosticPrescription",
            "kind": "LinkedField",
            "name": "ch_NeuropsychologicDiagnosticPrescription",
            "plural": false,
            "selections": [
              (v2/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "filters": null,
                "handle": "deleteRecord",
                "key": "",
                "kind": "ScalarHandle",
                "name": "id"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "75421fbe12c4e07755e857a39b840d29",
    "metadata": {},
    "name": "useChDeleteNeuropsychologicDiagnosticPrescriptionMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "7a7f66f9ff178e4742128f7e5914eaa9";

export default node;
